import React from 'react';

import { withClient } from './Misc/client';
import { Trans } from '@lingui/react/macro';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            year: new Date().getFullYear() > 2014 ? new Date().getFullYear() : 2017,
        };
    }

    render() {
        return (
            <div className="footer">
                <footer>
                    <Trans context="Footer">Copyright</Trans> © 2014-
                    <span id="footeryear">{this.state.year}</span>&nbsp;{' '}
                    <Trans context="Footer">Jewel Paymentech. All Rights Reserved.</Trans>
                </footer>
            </div>
        );
    }
}
export default withClient(Footer);
